import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { IconChevronDown, IconChevronUp } from '@noths/polaris-client-ribbons-design-system';
import * as styles from "./FooterLinksHeading.styles";
export var FooterLinksHeading = function FooterLinksHeading(_ref) {
  var isOpen = _ref.isOpen,
    title = _ref.title;
  return /*#__PURE__*/React.createElement(_StyledH, {
    style: {
      '--spacing': isOpen ? '8px' : '36px'
    },
    $_css: styles.heading
  }, /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css2: styles.title
  }, title), isOpen ? /*#__PURE__*/React.createElement(_StyledIconChevronUp, {
    $_css3: styles.icon
  }) : /*#__PURE__*/React.createElement(_StyledIconChevronDown, {
    $_css4: styles.icon
  }));
};
var _StyledH = _styled("h4")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledSpan = _styled2("span")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledIconChevronUp = _styled3(IconChevronUp)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledIconChevronDown = /*#__PURE__*/_styled4(IconChevronDown).withConfig({
  displayName: "FooterLinksHeading___StyledIconChevronDown",
  componentId: "sc-1xufepd-0"
})(["", ""], function (p) {
  return p.$_css4;
});